/* ======================================================================
   МОДУЛЬ: ОНЛАЙН-ЧАТ НА САЙТЕ С ДВУСТОРОННИМ МОСТОМ В TELEGRAM
   (Посетитель пишет на сайте -> админ отвечает через Reply в Telegram)
   ====================================================================== */

function initSiteLiveChat() {
  // Внутри Telegram WebApp плавающий чат не нужен: пользователь уже в Telegram и общается напрямую с ботом.
  // Плавающая кнопка перекрывает нижнюю панель меню ("Кабинет").
  if (window.Telegram?.WebApp?.initData) {
    return;
  }

  const path = window.location.pathname.toLowerCase();
  if (path.includes('admin.html') || path.includes('/admin')) {
    return;
  }

  if (document.getElementById('metaChatTriggerBtn')) {
    return;
  }

  // 1. Получаем или генерируем устойчивый ID сессии чата
  let chatSessionId = '';
  try {
    chatSessionId = localStorage.getItem('meta_site_chat_session') || '';
    if (!chatSessionId) {
      chatSessionId = 'sess_' + Math.random().toString(36).substring(2, 10) + Date.now().toString(36);
      localStorage.setItem('meta_site_chat_session', chatSessionId);
    }
  } catch (e) {
    chatSessionId = 'sess_' + Math.random().toString(36).substring(2, 10);
  }

  // 2. Создаем разметку кнопки и окна
  const chatDOM = `
    <!-- Кнопка вызова чата -->
    <button type="button" class="meta-chat-trigger-btn" id="metaChatTriggerBtn" aria-label="Написать в поддержку">
      <div class="meta-chat-trigger-icon-wrap">
        <span>💬</span>
        <span class="meta-chat-trigger-online-dot"></span>
      </div>
      <span class="meta-chat-trigger-label">Написать в поддержку</span>
      <span class="meta-chat-unread-badge" id="metaChatUnreadBadge" style="display: none;">0</span>
    </button>

    <!-- Окно чата -->
    <div class="meta-chat-window" id="metaChatWindow" role="dialog" aria-modal="true">
      <div class="meta-chat-header">
        <div class="meta-chat-header-profile">
          <div class="meta-chat-avatar">🏛</div>
          <div class="meta-chat-header-info">
            <span class="meta-chat-header-name">Служба заботы и поддержки</span>
            <span class="meta-chat-header-status">Константин Воробьев на связи</span>
          </div>
        </div>
        <button type="button" class="meta-chat-close-btn" id="metaChatCloseBtn" aria-label="Свернуть">✕</button>
      </div>

      <div class="meta-chat-body" id="metaChatBody">
        <div class="meta-chat-welcome">
          🌟 Здравствуйте! Задайте любой вопрос по программе марафона или курсу. Константин и кураторы ответят вам прямо здесь.
          <div style="margin-top: 8px; font-size: 11.5px; opacity: 0.95;">
            Или напишите нам в Telegram: <a href="https://t.me/meta_institut_bot" target="_blank" rel="noopener noreferrer" style="color: #1A8754; font-weight: 700; text-decoration: underline;">@meta_institut_bot</a>
          </div>
        </div>
        <div id="metaChatMessagesList"></div>
      </div>

      <form class="meta-chat-footer" id="metaChatForm" onsubmit="return false;">
        <input type="text" class="meta-chat-input" id="metaChatInput" placeholder="Напишите сообщение..." autocomplete="off">
        <button type="submit" class="meta-chat-send-btn" id="metaChatSendBtn" aria-label="Отправить">➤</button>
      </form>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', chatDOM);

  const triggerBtn = document.getElementById('metaChatTriggerBtn');
  const chatWindow = document.getElementById('metaChatWindow');
  const closeBtn = document.getElementById('metaChatCloseBtn');
  const chatBody = document.getElementById('metaChatBody');
  const msgsList = document.getElementById('metaChatMessagesList');
  const chatForm = document.getElementById('metaChatForm');
  const chatInput = document.getElementById('metaChatInput');
  const sendBtn = document.getElementById('metaChatSendBtn');
  const unreadBadge = document.getElementById('metaChatUnreadBadge');

  let isOpen = false;
  let pollInterval = null;
  let renderedMsgIds = new Set();
  let unreadCount = 0;
  let lastReadId = 0;
  try {
    lastReadId = parseInt(localStorage.getItem('meta_chat_last_read_id') || '0', 10);
  } catch (e) {}

  function scrollToBottom() {
    if (chatBody) {
      chatBody.scrollTop = chatBody.scrollHeight;
    }
  }

  function appendMessage(msg, isPoll) {
    if (renderedMsgIds.has(msg.id)) return;
    renderedMsgIds.add(msg.id);

    const isVisitor = msg.sender === 'visitor';
    const timeStr = msg.created_at ? new Date(msg.created_at).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' }) : '';

    const msgEl = document.createElement('div');
    msgEl.className = `meta-chat-msg ${isVisitor ? 'visitor' : 'admin'}`;
    msgEl.innerHTML = `
      <div class="meta-chat-bubble">${escapeHTML(msg.text)}</div>
      <span class="meta-chat-time">${timeStr}</span>
    `;

    msgsList.appendChild(msgEl);
    scrollToBottom();

    // Считаем непрочитанными только свежие входящие ответы куратора при закрытом окне
    if (!isVisitor && !isOpen && isPoll) {
      const msgId = Number(msg.id) || 0;
      if (msgId > lastReadId) {
        unreadCount++;
        if (unreadBadge) {
          unreadBadge.textContent = unreadCount;
          unreadBadge.style.display = 'inline-block';
        }
      }
    }
  }

  async function loadHistory() {
    try {
      const res = await fetch(`/api/chat/history?session_id=${encodeURIComponent(chatSessionId)}`);
      if (res.ok) {
        const data = await res.json();
        if (data.messages && Array.isArray(data.messages)) {
          let maxHistoryId = lastReadId;
          data.messages.forEach(function(m) {
            const mId = Number(m.id) || 0;
            if (mId > maxHistoryId) maxHistoryId = mId;
            appendMessage(m, false);
          });
          // Если чат открывается впервые, фиксируем историю как прочитанную
          if (!lastReadId && maxHistoryId > 0) {
            lastReadId = maxHistoryId;
            try {
              localStorage.setItem('meta_chat_last_read_id', String(lastReadId));
            } catch (e) {}
          }
        }
      }
    } catch (e) {
      console.warn('[SiteChat] Ошибка загрузки истории:', e);
    }
  }

  async function pollNewMessages() {
    try {
      const res = await fetch(`/api/chat/poll?session_id=${encodeURIComponent(chatSessionId)}`);
      if (res.ok) {
        const data = await res.json();
        if (data.messages && Array.isArray(data.messages)) {
          data.messages.forEach(function(m) {
            appendMessage(m, true);
          });
        }
      }
    } catch (e) {}
  }

  function openChat() {
    isOpen = true;
    chatWindow.classList.add('is-open');
    triggerBtn.style.display = 'none';
    unreadCount = 0;
    if (unreadBadge) {
      unreadBadge.style.display = 'none';
      unreadBadge.textContent = '0';
    }

    // Фиксируем все текущие сообщения как прочитанные
    let maxId = lastReadId;
    renderedMsgIds.forEach(function(id) {
      const num = Number(id) || 0;
      if (num > maxId) maxId = num;
    });
    if (maxId > lastReadId) {
      lastReadId = maxId;
      try {
        localStorage.setItem('meta_chat_last_read_id', String(lastReadId));
      } catch (e) {}
    }

    scrollToBottom();
    if (chatInput) chatInput.focus();

    if (pollInterval) clearInterval(pollInterval);
    pollInterval = setInterval(pollNewMessages, 4000);
    pollNewMessages();
  }

  function closeChat() {
    isOpen = false;
    chatWindow.classList.remove('is-open');
    triggerBtn.style.display = 'flex';

    if (pollInterval) clearInterval(pollInterval);
    // Фоновый редкий опрос раз в 15 секунд для проверки ответов
    pollInterval = setInterval(pollNewMessages, 15000);
  }

  triggerBtn.addEventListener('click', openChat);
  closeBtn.addEventListener('click', closeChat);

  async function handleSend() {
    const text = (chatInput.value || '').trim();
    if (!text) return;

    chatInput.value = '';
    sendBtn.disabled = true;

    let userName = 'Посетитель сайта';
    let userId = null;
    try {
      const prof = JSON.parse(localStorage.getItem('meta_user_profile') || '{}');
      if (prof.name) userName = prof.name;
      if (prof.id) userId = prof.id;
    } catch (e) {}

    // Оптимистичное отображение
    const tempId = 'temp_' + Date.now();
    appendMessage({
      id: tempId,
      sender: 'visitor',
      text: text,
      created_at: new Date().toISOString()
    });

    try {
      const res = await fetch('/api/chat/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          session_id: chatSessionId,
          text: text,
          name: userName,
          user_id: userId
        })
      });
      if (res.ok) {
        const data = await res.json();
        if (data.message && data.message.id) {
          renderedMsgIds.add(data.message.id);
        }
      }
    } catch (e) {
      console.warn('[SiteChat] Ошибка отправки:', e);
    } finally {
      sendBtn.disabled = false;
      if (chatInput) chatInput.focus();
    }
  }

  chatForm.addEventListener('submit', function(e) {
    e.preventDefault();
    handleSend();
  });

  // Первичная подгрузка истории сообщений
  loadHistory();
  pollInterval = setInterval(pollNewMessages, 15000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSiteLiveChat);
} else {
  initSiteLiveChat();
}